(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-funcionario', {
            parent: 'entity',
            url: '/ss-funcionario',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncionarios'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcionario/s-s-funcionarios.html',
                    controller: 'SSFuncionarioController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-funcionario-detail', {
            parent: 'ss-funcionario',
            url: '/ss-funcionario/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncionario'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-detail.html',
                    controller: 'SSFuncionarioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSFuncionario', function($stateParams, SSFuncionario) {
                    return SSFuncionario.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-funcionario',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-funcionario-detail.edit', {
            parent: 'ss-funcionario-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-dialog.html',
                    controller: 'SSFuncionarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncionario', function(SSFuncionario) {
                            return SSFuncionario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcionario.new', {
            parent: 'ss-funcionario',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-dialog.html',
                    controller: 'SSFuncionarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                puesto: null,
                                iniFunciones: null,
                                finFunciones: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-funcionario', null, { reload: 'ss-funcionario' });
                }, function() {
                    $state.go('ss-funcionario');
                });
            }]
        })
        .state('ss-funcionario.edit', {
            parent: 'ss-funcionario',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-dialog.html',
                    controller: 'SSFuncionarioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncionario', function(SSFuncionario) {
                            return SSFuncionario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcionario', null, { reload: 'ss-funcionario' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcionario.delete', {
            parent: 'ss-funcionario',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcionario/ss-funcionario-delete-dialog.html',
                    controller: 'SSFuncionarioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSFuncionario', function(SSFuncionario) {
                            return SSFuncionario.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcionario', null, { reload: 'ss-funcionario' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
